export default {
    okText: 'Ok',
    cancelText: 'Cancel',
};
